// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popover .chapters-list li {
  font-size: 13px;
}
.popover .chapters-list li:hover,
.popover .chapters-list li.active {
  cursor: pointer;
  color: #202020;
  font-weight: 600;
}

.get_ready_for_exam {
  position: relative;
}
.get_ready_for_exam .single-card {
  text-decoration: none;
  color: #202020;
}
.get_ready_for_exam .single-card:hover {
  text-decoration: none;
  background: #ffffff;
}
.get_ready_for_exam .single-card .iconBlock {
  text-align: center;
  width: 70px;
}
.get_ready_for_exam .single-card .Date {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 12px;
}
.get_ready_for_exam .single-card .buttons {
  padding-top: 10px;
}
.get_ready_for_exam .single-card .buttons .btn {
  font-size: 12px;
  margin-right: 10px;
}
.get_ready_for_exam .single-card .buttons .btn:last-child {
  margin-right: 0;
}
.get_ready_for_exam .single-card .buttons .btn-success {
  color: #28a745;
  background-color: hsla(134, 61%, 41%, 0.2);
  border-color: hsla(134, 61%, 41%, 0.2);
}
.get_ready_for_exam .single-card .buttons .btn-primary {
  color: #007bff;
  background-color: hsla(211, 100%, 50%, 0.2);
  border-color: hsla(211, 100%, 50%, 0.2);
}

.get_ready_for_exam_types {
  position: relative;
}
.get_ready_for_exam_types form .selectExamDate .input-group {
  flex-wrap: nowrap;
}
.get_ready_for_exam_types form .selectExamDate .input-group .rdt {
  width: 100%;
}
@media (min-width: 992px) {
  .get_ready_for_exam_types .aside {
    position: fixed;
    top: 55px;
    right: 0;
    width: 260px;
  }
}
.get_ready_for_exam_types .get_ready_for_exam_syllabus .card-group .card .subjects-list li:hover,
.get_ready_for_exam_types .get_ready_for_exam_syllabus .card-group .card .subjects-list li.active,
.get_ready_for_exam_types .get_ready_for_exam_syllabus .card-group .card .chapter-list li:hover,
.get_ready_for_exam_types .get_ready_for_exam_syllabus .card-group .card .chapter-list li.active {
  cursor: pointer;
  border-radius: 2px;
  background: #EFEFEF;
  padding: 0.2rem 0.5rem;
}
.get_ready_for_exam_types .get_ready_for_exam_syllabus .card-group .card .list-unstyled li {
  padding: 0.2rem 0.5rem;
  text-transform: uppercase;
}
@media (max-width: 991px) {
  .get_ready_for_exam_types .get_ready_for_exam_syllabus .card-group .card + .card {
    border-left: 1px solid rgba(0, 0, 0, 0.125) !important;
  }
}
@media (max-width: 991px) {
  .get_ready_for_exam_types .get_ready_for_exam_syllabus .card-group {
    display: flex;
    flex-flow: column wrap;
  }
  .get_ready_for_exam_types .get_ready_for_exam_syllabus .card-group .card {
    flex-direction: inherit;
    margin-bottom: 15px;
  }
}
.get_ready_for_exam_types .aside .single-list-card {
  margin-bottom: 4px;
}
.get_ready_for_exam_types .aside .single-list-card:last-child {
  margin-bottom: 0;
}
.get_ready_for_exam_types .aside .single-list-card .card-title {
  font-size: 15px;
}
.get_ready_for_exam_types .aside .single-list-card .topic-list li {
  padding: 6px 10px 0;
  margin-bottom: 4px;
}
.get_ready_for_exam_types .aside .single-list-card .topic-list li:last-child {
  margin-bottom: 0;
}
.get_ready_for_exam_types .table-borderless {
  margin-bottom: 0;
}
.get_ready_for_exam_types .table-borderless td,
.get_ready_for_exam_types .table-borderless th {
  padding: 0.3rem 0.5rem;
  border: 0;
}
.get_ready_for_exam_types .up-datedirection .rdtPicker {
  top: -270px;
}

.get_ready_exam_shortNote_materials .get_ready_exam_shortNotes_navs .nav-item .nav-link {
  color: #121412;
  font-weight: 400;
}
.get_ready_exam_shortNote_materials .get_ready_exam_shortNotes_navs .nav-item .nav-link.active {
  font-weight: 600;
  color: #007bff;
}
.get_ready_exam_shortNote_materials .section-description .breadcrumb-content .breadcrumb {
  background: transparent !important;
}
.get_ready_exam_shortNote_materials .section-description .breadcrumb-content .breadcrumb .breadcrumb-item a {
  text-decoration: none;
  color: #121412;
}
.get_ready_exam_shortNote_materials .shortnote_cards {
  margin: 0;
}
.get_ready_exam_shortNote_materials .shortnote_cards li.single_shortnote_list {
  margin-bottom: 20px;
}
.get_ready_exam_shortNote_materials .shortnote_cards li.single_shortnote_list:last-child {
  margin-bottom: 0;
}
.get_ready_exam_shortNote_materials .shortnote_cards li.single_shortnote_list a {
  text-decoration: none;
  color: #121412;
}
.get_ready_exam_shortNote_materials .shortnote_cards li.single_shortnote_list .single_card .card-body {
  overflow: hidden;
  position: relative;
  height: 90px;
  margin-bottom: 15px;
}
.get_ready_exam_shortNote_materials .shortnote_cards li.single_shortnote_list .single_card.fullView .card-body {
  height: 100%;
}
.get_ready_exam_shortNote_materials .shortnote_cards li.single_shortnote_list .single_card .helpTags li.list-inline-item {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.5254901961);
}
.get_ready_exam_shortNote_materials .material_cards .single_material_list {
  position: relative;
  margin-bottom: 20px;
}
.get_ready_exam_shortNote_materials .material_cards .single_material_list:last-child {
  margin-bottom: 0;
}
.get_ready_exam_shortNote_materials .material_cards .single_material_list .single_card .helpTags li.list-inline-item {
  cursor: pointer;
  color: rgba(0, 0, 0, 0.5254901961);
}
.get_ready_exam_shortNote_materials #filter-popover.popover {
  max-width: 300px !important;
}
@media (max-width: 991px) {
  .get_ready_exam_shortNote_materials #filter-popover.popover .card-group .card + .card {
    border-left: 1px solid rgba(0, 0, 0, 0.125) !important;
  }
}
@media (max-width: 991px) {
  .get_ready_exam_shortNote_materials #filter-popover.popover .card-group {
    display: flex;
    flex-flow: column wrap;
  }
  .get_ready_exam_shortNote_materials #filter-popover.popover .card-group .card {
    flex-direction: inherit;
    margin-bottom: 15px;
  }
}
.get_ready_exam_shortNote_materials #filter-popover.popover .popover-body {
  padding: 0;
}
.get_ready_exam_shortNote_materials #filter-popover.popover .popover-body .nav-tabs {
  background: #f8f9fa;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.get_ready_exam_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-item {
  margin-bottom: 0;
}
.get_ready_exam_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-item .nav-link {
  border: none;
}
.get_ready_exam_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-link {
  font-weight: 500;
  border: none;
  color: #495057;
}
.get_ready_exam_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-link.active,
.get_ready_exam_shortNote_materials #filter-popover.popover .popover-body .nav-tabs .nav-item.show .nav-link {
  font-weight: 600;
  color: #121412;
  background-color: #f8f9fa;
  border-bottom: 2px solid #3ac555;
}
.get_ready_exam_shortNote_materials #filter-popover.popover .popover-body .tab-content {
  padding: 0.5rem 0.5rem 0;
  max-height: 130px;
  overflow-y: scroll;
}
.get_ready_exam_shortNote_materials #filter-popover.popover .popover-body .tab-content .custom-list li {
  margin-bottom: 6px;
}
.get_ready_exam_shortNote_materials #filter-popover.popover .popover-body .tab-content .custom-list li:not(:last-child) {
  margin-right: 0;
}
.get_ready_exam_shortNote_materials #filter-popover.popover .popover-body .tab-content .custom-list li .text {
  width: 250px;
  line-height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/get_ready_for_exam/_readyforexam.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR;AAEI;;EAEI,eAAA;EACA,cAAA;EACA,gBAAA;AAAR;;AAIA;EACI,kBAAA;AADJ;AAGI;EACI,qBAAA;EACA,cAAA;AADR;AAGQ;EACI,qBAAA;EACA,mBAAA;AADZ;AAIQ;EACI,kBAAA;EACA,WAAA;AAFZ;AAKQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;AAHZ;AAMQ;EACI,iBAAA;AAJZ;AAMY;EACI,eAAA;EACA,kBAAA;AAJhB;AAMgB;EACI,eAAA;AAJpB;AAQY;EACI,cAAA;EACA,0CAAA;EACA,sCAAA;AANhB;AASY;EACI,cAAA;EACA,2CAAA;EACA,uCAAA;AAPhB;;AAaA;EACI,kBAAA;AAVJ;AAaQ;EACI,iBAAA;AAXZ;AAaY;EACI,WAAA;AAXhB;AAiBQ;EADJ;IAEQ,eAAA;IACA,SAAA;IACA,QAAA;IACA,YAAA;EAdV;AACF;AAsBgB;;;;EAII,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AApBpB;AAuBgB;EACI,sBAAA;EACA,yBAAA;AArBpB;AA0BQ;EACI;IACI,sDAAA;EAxBd;AACF;AA2BQ;EACI;IACI,aAAA;IACA,sBAAA;EAzBd;EA2Bc;IACI,uBAAA;IACA,mBAAA;EAzBlB;AACF;AA8BI;EACI,kBAAA;AA5BR;AA8BQ;EACI,gBAAA;AA5BZ;AA+BQ;EACI,eAAA;AA7BZ;AAgCQ;EACI,mBAAA;EACA,kBAAA;AA9BZ;AAgCY;EACI,gBAAA;AA9BhB;AAmCI;EACI,gBAAA;AAjCR;AAmCQ;;EAEI,sBAAA;EACA,SAAA;AAjCZ;AAoCI;EACI,WAAA;AAlCR;;AAwCQ;EACI,cAAA;EACA,gBAAA;AArCZ;AAuCY;EACI,gBAAA;EACA,cAAA;AArChB;AA8CY;EACI,kCAAA;AA5ChB;AA8CgB;EACI,qBAAA;EACA,cAAA;AA5CpB;AAkDI;EACI,SAAA;AAhDR;AAkDQ;EACI,mBAAA;AAhDZ;AAkDY;EACI,gBAAA;AAhDhB;AAmDY;EACI,qBAAA;EACA,cAAA;AAjDhB;AAqDgB;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AAnDpB;AAuDoB;EACI,YAAA;AArDxB;AAyDgB;EACI,eAAA;EACA,kCAAA;AAvDpB;AA6DI;EACI,kBAAA;EACA,mBAAA;AA3DR;AA6DQ;EACI,gBAAA;AA3DZ;AA+DY;EACI,eAAA;EACA,kCAAA;AA7DhB;AAkEI;EACI,2BAAA;AAhER;AAkEQ;EACI;IACI,sDAAA;EAhEd;AACF;AAmEQ;EACI;IACI,aAAA;IACA,sBAAA;EAjEd;EAmEc;IACI,uBAAA;IACA,mBAAA;EAjElB;AACF;AAqEQ;EACI,UAAA;AAnEZ;AAqEY;EACI,mBAAA;EACA,+BAAA;EACA,gCAAA;AAnEhB;AAsEY;EACI,gBAAA;AApEhB;AAsEgB;EACI,YAAA;AApEpB;AAwEY;EACI,gBAAA;EACA,YAAA;EACA,cAAA;AAtEhB;AAyEY;;EAEI,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,gCAAA;AAvEhB;AA0EY;EACI,wBAAA;EACA,iBAAA;EACA,kBAAA;AAxEhB;AA0EgB;EACI,kBAAA;AAxEpB;AA0EoB;EACI,eAAA;AAxExB;AA2EoB;EACI,YAAA;EACA,iBAAA;AAzExB","sourcesContent":[".popover{\n    .chapters-list li {\n        font-size: 13px;\n    }\n    .chapters-list li:hover,\n    .chapters-list li.active {\n        cursor: pointer;\n        color: #202020;\n        font-weight: 600;\n        \n    }\n}\n.get_ready_for_exam {\n    position: relative;\n    \n    .single-card {\n        text-decoration: none;\n        color: #202020;\n\n        &:hover {\n            text-decoration: none;\n            background: #ffffff;\n        }\n\n        .iconBlock {\n            text-align: center;\n            width: 70px;\n        }\n\n        .Date {\n            position: absolute;\n            top: 5px;\n            right: 5px;\n            font-size: 12px;\n        }\n\n        .buttons {\n            padding-top: 10px;\n\n            .btn {\n                font-size: 12px;\n                margin-right: 10px;\n\n                &:last-child {\n                    margin-right: 0;\n                }\n            }\n\n            .btn-success {\n                color: #28a745;\n                background-color: hsla(134, 61%, 41%, 0.2);\n                border-color: hsla(134, 61%, 41%, 0.2);\n            }\n\n            .btn-primary {\n                color: #007bff;\n                background-color: hsla(211, 100%, 50%, 0.2);\n                border-color: hsla(211, 100%, 50%, 0.2);\n            }\n        }\n    }\n}\n\n.get_ready_for_exam_types {\n    position: relative;\n\n    form .selectExamDate {\n        .input-group {\n            flex-wrap: nowrap;\n\n            .rdt {\n                width: 100%;\n            }\n        }\n    }\n\n    .aside {\n        @media (min-width: 992px) {\n            position: fixed;\n            top: 55px;\n            right: 0;\n            width: 260px;\n        }\n    }\n\n    .get_ready_for_exam_syllabus {\n        \n        .card-group {\n            .card {\n\n                .subjects-list li:hover,\n                .subjects-list li.active,\n                .chapter-list li:hover,\n                .chapter-list li.active {\n                    cursor: pointer;\n                    border-radius: 2px;\n                    background: #EFEFEF;\n                    padding: 0.2rem 0.5rem;\n                }\n\n                .list-unstyled li {\n                    padding: 0.2rem 0.5rem;\n                    text-transform: uppercase;\n                }\n            }\n        }\n\n        @media (max-width: 991px) {\n            .card-group .card+.card {\n                border-left: 1px solid rgba(0, 0, 0, 0.125) !important;\n            }\n        }\n\n        @media (max-width: 991px) {\n            .card-group {\n                display: flex;\n                flex-flow: column wrap;\n\n                .card {\n                    flex-direction: inherit;\n                    margin-bottom: 15px;\n                }\n            }\n        }\n    }\n\n    .aside .single-list-card {\n        margin-bottom: 4px;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n\n        .card-title {\n            font-size: 15px;\n        }\n\n        .topic-list li {\n            padding: 6px 10px 0;\n            margin-bottom: 4px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n    }\n\n    .table-borderless {\n        margin-bottom: 0;\n\n        td,\n        th {\n            padding: 0.3rem 0.5rem;\n            border: 0;\n        }\n    }\n    .up-datedirection .rdtPicker {\n        top: -270px;\n    }\n}\n\n.get_ready_exam_shortNote_materials {\n    .get_ready_exam_shortNotes_navs {\n        .nav-item .nav-link {\n            color: #121412;\n            font-weight: 400;\n\n            &.active {\n                font-weight: 600;\n                color: #007bff\n            }\n        }\n    }\n\n    .section-description {\n        // background-color: #e9ecef;\n\n        .breadcrumb-content {\n            .breadcrumb {\n                background: transparent !important;\n\n                .breadcrumb-item a {\n                    text-decoration: none;\n                    color: #121412;\n                }\n            }\n        }\n    }\n\n    .shortnote_cards {\n        margin: 0;\n\n        li.single_shortnote_list {\n            margin-bottom: 20px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n\n            a {\n                text-decoration: none;\n                color: #121412;\n            }\n\n            .single_card {\n                .card-body {\n                    overflow: hidden;\n                    position: relative;\n                    height: 90px;\n                    margin-bottom: 15px;\n                }\n\n                &.fullView {\n                    .card-body {\n                        height: 100%;\n                    }\n                }\n\n                .helpTags li.list-inline-item {\n                    cursor: pointer;\n                    color: #00000086;\n                }\n            }\n        }\n    }\n\n    .material_cards .single_material_list {\n        position: relative;\n        margin-bottom: 20px;\n\n        &:last-child {\n            margin-bottom: 0;\n        }\n\n        .single_card {\n            .helpTags li.list-inline-item {\n                cursor: pointer;\n                color: #00000086;\n            }\n        }\n    }\n\n    #filter-popover.popover {\n        max-width: 300px !important;\n\n        @media (max-width: 991px) {\n            .card-group .card+.card {\n                border-left: 1px solid rgba(0, 0, 0, 0.125) !important;\n            }\n        }\n\n        @media (max-width: 991px) {\n            .card-group {\n                display: flex;\n                flex-flow: column wrap;\n\n                .card {\n                    flex-direction: inherit;\n                    margin-bottom: 15px;\n                }\n            }\n        }\n\n        .popover-body {\n            padding: 0;\n\n            .nav-tabs {\n                background: #f8f9fa;\n                border-top-left-radius: 0.25rem;\n                border-top-right-radius: 0.25rem;\n            }\n\n            .nav-tabs .nav-item {\n                margin-bottom: 0;\n\n                .nav-link {\n                    border: none;\n                }\n            }\n\n            .nav-tabs .nav-link {\n                font-weight: 500;\n                border: none;\n                color: #495057;\n            }\n\n            .nav-tabs .nav-link.active,\n            .nav-tabs .nav-item.show .nav-link {\n                font-weight: 600;\n                color: #121412;\n                background-color: #f8f9fa;\n                border-bottom: 2px solid #3ac555;\n            }\n\n            .tab-content {\n                padding: 0.5rem 0.5rem 0;\n                max-height: 130px;\n                overflow-y: scroll;\n\n                .custom-list li {\n                    margin-bottom: 6px;\n\n                    &:not(:last-child) {\n                        margin-right: 0;\n                    }\n\n                    .text {\n                        width: 250px;\n                        line-height: 20px;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
